<template>
  <div>
    <PageTitle>
      <b-container>
        <h1 class="display-3">Enrolment Projections</h1>
        <p class="lead">
          Here are the existing schools currently recognised by the cost benefit
          analysis tool. To update this information, upload a new CSV.
        </p>
      </b-container>
    </PageTitle>
    <b-overlay :show="loading" rounded="sm" no-wrap fixed />
    <b-container>
      <b-row>
        <b-col cols="4">
          <b-card no-body>
            <template v-slot:header>
              <b-card-title
                class="d-flex justify-content-between align-items-center"
              >
                Update enrolment projections
              </b-card-title>
            </template>
            <b-card-body>
              <b-card-text>
                <b-alert
                  v-for="err in data_errors"
                  :key="err"
                  show
                  variant="danger"
                >
                  {{ err }}
                </b-alert>
                <vue-csv-import
                  :autoMatchFields="true"
                  :autoMatchIgnoreCase="true"
                  url="/"
                  v-model="csv"
                  :mapFields="input_fields"
                  :headers="true"
                  :canIgnore="false"
                  tableClass="table b-table table-striped table-hover border"
                  checkboxClass="custom-control-input"
                  buttonClass="btn btn-primary btn-block"
                  inputClass="custom-file-input"
                  @input="submit($event)"
                >
                </vue-csv-import>
                <!-- <vue-file-upload
                  :autoMatchFields="true"
                  :autoMatchIgnoreCase="true"
                  url="/"
                  v-model="csv"
                  :mapFields="input_fields"
                  :headers="true"
                  :canIgnore="false"
                  tableClass="table b-table table-striped table-hover border"
                  checkboxClass="custom-control-input"
                  buttonClass="btn btn-primary btn-block"
                  inputClass="custom-file-input"
                  @input="submit($event)"
                >
                </vue-file-upload> -->
              </b-card-text>
            </b-card-body>
          </b-card>
        </b-col>
        <b-col>
          <Table
            :filter_toggle="true"
            :fields="fields"
            :items="items"
            :selectable="selectMultiple"
            @filter="onFilter"
            @deleteObject="deleteProject($event)"
          >
          </Table>
        </b-col>
      </b-row>
    </b-container>
    <b-modal
      id="response"
      title="Parameter update results"
      hide-footer
      no-stacking
    >
      <div class="d-block text-left">
        <p>{{ this.server_response }}</p>
      </div>
      <br />
      <b-row>
        <b-col>
          <b-button block variant="sgs-blue" @click="go_to('ProjectList')">
            View project list
          </b-button>
        </b-col>
        <b-col>
          <b-button block variant="sgs-green" @click="close()">
            Close
          </b-button>
        </b-col>
      </b-row>
      <!-- <b-button variant="secondary" @click="go_to_project_list">
        Close
      </b-button> -->
    </b-modal>
  </div>
</template>

<script>
import PageTitle from "@/components/PageTitle.vue";
import Table from "@/components/Table.vue";
import VueCsvImport from "@/components/VueCsvImport.vue";

export default {
  name: "EnrolmentProjectionList",
  components: {
    PageTitle,
    Table,
    VueCsvImport,
  },
  props: {},
  data() {
    return {
      error: false,
      loading: false,
      fields: [
        {
          key: "type",
          label: "Type",
          sortable: true,
        },
        {
          key: "school_name",
          label: "School",
          sortable: true,
        },
        {
          key: "level",
          label: "Level",
          sortable: true,
        },
        {
          key: "year",
          label: "Year",
          sortable: true,
        },
        {
          key: "total",
          label: "Total",
          format: "0,0.[00]",
          class: "text-right",
          sortable: true,
        },
      ],
      items: [],
      input_fields: {
        type: { label: "type" },
        school_name: { label: "school_name" },
        level: { label: "level" },
        year: { label: "year" },
        total: { label: "total" },
        school_id: { label: "school_id" },
        kindergarten: { label: "kindergarten" },
        year1: { label: "year1" },
        year2: { label: "year2" },
        year3: { label: "year3" },
        year4: { label: "year4" },
        year5: { label: "year5" },
        year6: { label: "year6" },
        support_primary: { label: "support_primary" },
        year7: { label: "year7" },
        year8: { label: "year8" },
        year9: { label: "year9" },
        year10: { label: "year10" },
        year11: { label: "year11" },
        year12: { label: "year12" },
        support_secondary: { label: "support_secondary" },
        ssp: { label: "ssp" },
      },
      data_errors: [],
    };
  },
  methods: {
    getParameters() {
      this.$store
        .dispatch("get", {
          url: "/enrolment_projection",
        })
        .then((response) => {
          this.loading = false;
          this.items = response.data.items;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error.response.data);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submit(event) {
      console.log(event);
      this.loading = true;
      this.$store
        .dispatch("post", {
          data: event,
          url: "/enrolment_projection/update/csv",
        })
        .then((response) => {
          this.loading = false;
          console.log(response.data);
          this.server_response = response.data;
          this.$bvModal.show("response");
        })
        .catch((error) => {
          this.loading = false;
          console.log(error.response.data);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    go_to(name) {
      this.$router.push({ name: name });
    },
  },
  mounted() {
    this.getParameters();
    if (!this.isAdmin) {
      this.$router.push({ name: "logout" });
    }
  },
  created() {},
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
  },
};
</script>
